<template>

    <div class="layout__container">

        <div class="layout__margin-25-0">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Sales Insight</el-breadcrumb-item>
                <el-breadcrumb-item><span class="text__colour-teal">Month End Tasks</span></el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="layout__position-center">
            <div class="layout__position-left layout__width-100">
                <div class="layout__search-field__insights-250px">
                    <p class="layout__margin__bottom-10 text__align-left">Select Report</p>
                    <el-select v-model="dropdownValue" placeholder="Select Report" clearable @change="swapComponent">
                        <el-option
                            v-for="component in componentsArray"
                            :key="component.value"
                            :label="component.label"
                            :value="component.value">
                        </el-option>
                    </el-select>
                </div>
            </div>

            <div class="layout__position-left layout__width-100">
                <div id="toReplace">
                    <div :is="currentComponent"></div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import MonthlyInvoicingList from '@/views/insights/MonthlyInvoicingList';
 
    export default {
        name: "sales",
        mixins: [],
        components: {
            MonthlyInvoicingList
        },
        props: {
            view: ''
        },
        created() {
            this.isUserAuthorised();
        },
        data() {
            return {
                dropdownValue: '',
                currentComponent: null,
                componentsArray: [{
                    value: 'MonthlyInvoicingList',
                    label: 'Monthly Invoicing List'
                }]
            }
        },
        methods: {
            swapComponent: function(component) {
                console.log('dropdownValue=' + this.dropdownValue);
                this.currentComponent = component;
            }
        }
    };
</script>